import type { AddressAutocompleteOption } from './addressAutocompleteOption.interface';
import { ScreeningResultsTypes } from '../../features/RenterInvite/ScreeningResultsTypes';
import { RentCoverageTypes, SecurityDepositTypes } from '../../constants/CoverageType';
import type { CoveragePricing } from '@/shared/types';

export enum RenterInviteType {
  SMBInviteOldCustomCoverage = 'SMB_Invite_old_custom_coverage',
  SMBInviteNewLimitedSdr = 'SMB_Invite_new_limited_sdr',
}

// The form stores an AddressAutocompleteOption at runtime via the autocomplete onChange.
// Partial<> satisfies the Yup resolver's narrow inferred type while giving access to all fields.
export type Address = Partial<AddressAutocompleteOption> & {
  monolith_building_id: number;
};

export interface Renter {
  approvalStatus?: ScreeningResultsTypes | '';
  address: Address;
  apartmentNumber: string;
  leaseStart: Date;
  leaseEnd: Date;
  grossMonthlyRent: number;
  prepaidRent?: number;
  freeRent?: number;
  applicantEmails: { value: string }[];
  rentCoverage: RentCoverageTypes;
  monthsOfCoverage?: number;
  securityDepositCoverage: SecurityDepositTypes;
  securityDepositReplacementAmount?: number;
  customCoverage?: boolean;
  includeDepositCoverage?: boolean;
  selectedSmbPricing?: CoveragePricing;
}

export enum CoverageType {
  RentCoverage = 'rentCoverage',
  SecurityDepositCoverage = 'securityDepositCoverage',
}
